// ─── Shared bundle entry point ────────────────────────────────────────────────
// Compiled to js/global.js (loaded once in templates/layouts/base.html, after
// jQuery). Re-exports the shared ui/ helpers for back-compat with existing
// importers (including js/global.test.ts), then bootstraps the page.

export {
  closeAll,
  domReady,
  insertAfter,
  toggleDisabled,
  toggleLang,
  toggleNav,
  toggleSearch,
} from "./src/ui/dom"
export type { ValidationResult } from "./src/ui/validation"
export {
  PASSWORD_ERROR_MESSAGES,
  validatePass,
} from "./src/ui/validation"

import { initObservability } from "./src/core/observability"
import { initModules } from "./src/modules/registry"
import { domReady } from "./src/ui/dom"
import { initFormEnhancements } from "./src/ui/form-enhancements"
import { initHeader } from "./src/ui/header"
import { PASSWORD_ERROR_MESSAGES } from "./src/ui/validation"

// First, at module evaluation rather than on domReady: a module that throws during its own init
// must still be captured, and initialization must not wait for the registry bootstrap.
initObservability()

window.PASSWORD_ERROR_MESSAGES = PASSWORD_ERROR_MESSAGES

domReady(() => {
  initModules()

  if (!document.body) return

  initHeader()
  initFormEnhancements()
})
